/** @file Package version constant for @pose2d/compiler. */
export const VERSION = '0.0.0';
